import $ from "jquery";
import * as GC from "../../../../../common/common";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";

export default function normal() {
}

export const FillTableCallBack = (result, page_number, columnList) => {
    let oTable = $("#example2")?.dataTable();
    let totalCount = 0;
    if (!oTable){
        return
    }
    if (page_number === 1) {
        oTable.fnClearTable();
    }
    if (page_number <= result.meta.total_pages) {
        if (result.data.length > 0) {
            $.each(result.data, function (index, data) {
                if (!data.content){
                    return;
                }
                const checkbox =
                    '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

                const circleType =
                    data.content["algemeen-actief"] === true
                        ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
                        : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';

                const isGeneralExecutor =
                    data.content["algemeen-isuitvoerder"] === true
                        ? '<div class="green-circle rounded-circle"><span class="tooltiptext">True</span></div>'
                        : '<div class="red-circle rounded-circle"><span class="tooltiptext">False</span></div>';

                let name = data.content["algemeen-naamorganisatie"];
                if (typeof name === "undefined") {
                    name = "";
                }

                let email = `<a href="mailto:${data.content["algemeen-email"]}">${data.content["algemeen-email"]}</a>`;
                if (typeof email === "undefined") {
                    email = "";
                }

                let webSite = data.content["algemeen-website"];
                if (typeof webSite === "undefined") {
                    webSite = "";
                }

                //opmerking
                let remark = data.content["algemeen-opmerking"];
                if (typeof remark === "undefined") {
                    remark = "";
                }

                //straat
                let street = data.content["algemeen-straat"];
                if (typeof street === "undefined") {
                    street = "";
                }

                let number = data.content["algemeen-nummer"];
                if (typeof number === "undefined") {
                    number = "";
                }

                let postCode = data.content["algemeen-postcode"];
                if (typeof postCode === "undefined") {
                    postCode = "";
                }

                //woonplaats
                let residence = data.content["algemeen-woonplaats"];
                if (typeof residence === "undefined") {
                    residence = "";
                }

                const test = {
                    checkbox: checkbox,
                    active: circleType,
                    isGeneralExecutor: isGeneralExecutor,
                    Naam: name,
                    Email: email,
                    Website: webSite,
                    Opmerking: remark,
                    Straat: street,
                    Number: number,
                    Postcode: postCode,
                    Woonplaats: residence,
                };

                let _columnList = Object.values(test);
                // if (columnList && columnList.column_list) {
                //     for (let column in columnList.column_list) {
                //         for (let key in test) {
                //             if (
                //                 columnList.column_list[column].toLowerCase() === key.toLowerCase()
                //             ) {
                //                 _columnList.push(test[key]);
                //             }
                //         }
                //     }
                // }

                window.$catalog_users_organizations_Glist.push(
                    {
                        identification: data["identification"],
                        actief: data.content["algemeen-actief"],
                        isuitvoerder: data.content["algemeen-isuitvoerder"],
                        naamorganisatie: name,
                        email: email,
                        emailClear:data.content["algemeen-email"],
                        website: webSite,
                        opmerking: remark,
                        straat: street,
                        nummer: number,
                        postcode: postCode,
                        woonplaats: residence,
                        isEditable: true,
                        timestampUpdated: data["timestamp_updated"],
                        timestampCreated: data["timestamp_created"],
                        relations: data.relationships.context
                    }
                );
                const addId = oTable.fnAddData(
                    [
                        ..._columnList
                    ],
                    false
                );

                if (addId.length > 0) {
                    const theNode = $("#example2").dataTable().fnSettings().aoData[
                        addId[0]
                        ].nTr;
                    theNode.setAttribute("rowId", data["identification"]);
                }
            });
            oTable.fnDraw();
        } else {
            $("tbody").html();
            oTable.fnClearTable();
        }
    }
    $("#total-rows").html(result.meta.total_found - totalCount);
    window.$catalog_users_organizations_total_row = result.meta.total_found - totalCount;
    // window.$catalog_users_organizations_real_total_row = result.meta.total_found;
    $("#cover-spin").hide(0);
    window.$catalog_users_organizations_treeChangeStatus = true;
    window.$catalog_users_organizations_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
    if (data === "user-gebruikersrollen") {
        window.$catalog_users_organizations_gebruikersrollen.length = 0;
        $.each(result.data, function (index, data) {
            window.$catalog_users_organizations_gebruikersrollen.push(data);
        });
    }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
    if (searchId === "user-alias") {
        window.$catalog_users_organizations_user_alias.length = 0;
        $.each(result, function (index, data) {
            window.$catalog_users_organizations_user_alias.push(data);
        });
    }
    if (searchId === "user-email") {
        window.$catalog_users_organizations_user_email.length = 0;
        $.each(result, function (index, data) {
            window.$catalog_users_organizations_user_email.push(data);
        });
    }
    if (searchId === "user-gebruikersrollen") {
        window.$catalog_users_organizations_gebruikersrollen.length = 0;
        $.each(result.data, function (index, data) {
            window.$catalog_users_organizations_gebruikersrollen.push(data.name);
        });
    }
    if (searchId === "user-organisatie") {
        window.$catalog_users_organizations_organisatie.length = 0;
        $.each(result.data, function (index, data) {
            window.$catalog_users_organizations_organisatie.push(data.name);
        });
    }
};

/**
 * * tablo değişikliklerini dinamik olarak takip eder
 */
function getTable() {
    GC.sleep(1500).then(() => {
        omnimap
            .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_organizations_token)
            .then((result) => {
                if (window.$catalog_users_organizations_real_total_row !== result.data.length) {
                    FillTableCallBack(result, 1);
                } else getTable();
            });
    });
}

export const RowsDeletedCallBack = async (token) => {
    GC.sleep(500).then(() => {
        $("#user-delete-modal").modal("hide");
        omnimap
            .GetAllUsersAction(1, 100, "", "", "", "", window.$catalog_users_organizations_token)
            .then(async (result) => {
                window.$catalog_users_organizations_real_total_row = await result.data.length;
                FillTableCallBack(result, 1);
                await getTable();
            });
    });
};

export const GetActionsOfRowCallback = async (result) => {
    const actionsOfSelection = [];
    const popup = $("#myPopup")
    popup.html("");
    $.each(window.$catalog_users_organizations_actions, function (index, action) {
        if ($.inArray(action["id"], actionsOfSelection) !== -1) {
            const anchor = $("<a></a>")
                .attr({href: "javascript:void(0)", id: action["id"]})
                .addClass(action["class"] + " catalog-action")
                .html(action["text"]);
            popup.append(anchor);
        }
    });

    /**
     *  * aktif olmayan actionlar burada listeleniyor.
     **/
    // $.each(actionsOfDisabled, function (index, action) {
    //   var anchor = $("<a disabled></a>")
    //     .attr({ href: "javascript:void(0)", id: action["identification"] })
    //     .addClass("disabled" + " catalog-action")
    //     .html(action["name"]);
    //   $("#myPopup").append(anchor);
    // });

    if (window.$catalog_users_organizations_selectedIds.length > 0) {
        const tmp3 = $("<a></a>")
            .attr({href: "javascript:void(0)", id: "user-verwijderen"})
            .addClass("trash-bin beheereenheid")
            .html("Gebruiker verwijderen");
        popup.append(tmp3);
    } else {
        const tmp1 = $("<a></a>")
            .attr({href: "javascript:void(0)", id: "cat-user-add"})
            .addClass("user beheereenheid")
            .html("Gebruiker toevoegen");
        popup.append(tmp1);
        const tmp2 = $("<a></a>")
            .attr({href: "javascript:void(0)", id: "cat-organisatie-add"})
            .addClass("")
            .html("Organisatie toevoegen");
        popup.append(tmp2);
    }

    document.getElementById("myPopup").classList.toggle("show");
};

export function TableColumnChangeHandler(
    settings,
    data,
    identification,
    columnOrderReference,
    COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
    const names = settings.aoColumns;
    if (names[0]) {
    }
    const test_list = [];
    names.forEach((element, index) => {
        test_list.push(element.sTitle);
    });

    const isGeneralExecutorIndex = test_list.findIndex((x) =>
        x.includes("Is uitvoerder")
    );
    test_list[isGeneralExecutorIndex] = "isGeneralExecutor";

    const checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
    test_list[checkIndex] = "checkbox";
    const statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
    test_list[statusIndex] = "active";
    const model = {
        identification: identification,
        code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
        client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
        reference: columnOrderReference,
        data: {
            table_sorting: [
                {
                    name: "catalog>users>organizations",
                    column_list: test_list,
                },
            ],
        },
    };
    /*var asd = (model.data.table_sorting.find(
        (x) => x.name === "catalog>users>organizations"
    ).column_list = test_list);*/
    omnimap.GetFreeFormatAction(identification, "PUT", model);

    return model.data.table_sorting[0];
}
